import { useLanguage } from '../context/LanguageContext';
import { navigationTranslations } from '../translations/navigation';

export function useNavigationTranslation() {
    const { language } = useLanguage();

    const getTabLabel = (tabId: string): string => {
        return navigationTranslations.tabs[tabId as keyof typeof navigationTranslations.tabs]?.[language] || tabId;
    };

    const getSubTabLabel = (subtabId: string): string => {
        return navigationTranslations.subtabs[subtabId as keyof typeof navigationTranslations.subtabs]?.[language] || subtabId;
    };

    const getProductLabel = (productId: string): string => {
        return navigationTranslations.products[productId as keyof typeof navigationTranslations.products]?.[language] || productId;
    };

    return {
        getTabLabel,
        getSubTabLabel,
        getProductLabel
    };
} 